import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";
import { MdPendingActions } from "react-icons/md";
import { FaFileExcel } from "react-icons/fa";

import { FaBed } from "react-icons/fa";
import { IoMdNotifications } from "react-icons/io";
import {
  FaHome,
  FaUsers,
  FaChartBar,
  FaCreditCard,
  FaBuilding,
} from "react-icons/fa";
import { MdRestaurantMenu } from "react-icons/md";

import API from "./config/API";

function FloorRooms() {
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();

  const [profilePic, setProfilePic] = useState("");
  const [pendingWorksCount, setPendingWorksCount] = useState(0);
  const [userRegisterId, setUserRegisterId] = useState(null);

  const user = JSON.parse(localStorage.getItem("user")) || {};

  const [hoveredMenu, setHoveredMenu] = useState("");

  const [dashboardData, setDashboardData] = useState({
    availableBedsCount: 0,
    guestUsersCount: 0,
    payment_No_pendingUsersCount: 0,
    payment_due_usersCount: 0,
    readyToJoiningUsersCount: 0,
    readyTovacatUsersCount: 0,
    totalBedsCount: 0,
    totalFloorsCount: 0,
    totalRoomsCount: 0,
    totalUsersCountInPg: 0,
    totalTenentUsersCount: 0,
    totalRefferalsCount: 0,
    totalRefferalsAmount: 0.0,
  });

  const [totalAvailableBeds, setTotalAvailableBeds] = useState(0);

  useEffect(() => {
    if (user.userId) {
      fetchProfilePic();
    }
  }, []);

  const handleLogout = async () => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!window.confirm("Are you sure you want to logout?")) {
      return;
    }

    try {
      const response = await fetch(`${API.V1}/pgOwner/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.jwtToken}`, // or user.jwtToken.jwtToken
        },
        body: JSON.stringify({
          userId: user.userId,
        }),
      });

      const result = await response.json();

      if (result.statusCode === 200) {
        // alert(result.message);

        localStorage.clear();
        sessionStorage.clear();

        navigate("/", { replace: true });
      }
    } catch (error) {
      console.error(error);
      alert("Unable to logout.");
    }
  };

  const handleReadyToVacate = async () => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("user"));

      if (!loggedUser?.emailId) {
        alert("User email not found. Please login again.");
        return;
      }

      const token = loggedUser.jwtToken;

      const response = await fetch(
        `${API.V2}/pgOwner/getReadyJoinAndVacateUsers?emailId=${encodeURIComponent(
          loggedUser.emailId,
        )}&userType=READY_TO_VACATE`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 401) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/";
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch Ready To Vacate users");
      }

      const data = await response.json();

      console.log("Ready To Vacate Users:", data);

      // Navigate to Ready To Vacate page and send API response
      navigate("/readyToJoinUsers", {
        state: {
          userType: "READY_TO_VACATE",
          users: data?.data || [],
        },
      });
    } catch (error) {
      console.error("Ready To Vacate API error:", error);
      alert("Unable to fetch Ready To Vacate users.");
    }
  };

  const fetchProfilePic = async () => {
    try {
      const token = localStorage.getItem("jwtToken");

      const response = await fetch(
        `${API.V1}/pgOwner/getProfilePic?userId=${user.userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.ok) {
        const imageUrl = await response.text();

        setProfilePic(imageUrl);

        // Update localStorage
        const updatedUser = {
          ...user,
          profileImage: imageUrl,
        };

        localStorage.setItem("user", JSON.stringify(updatedUser));
      } else if (response.status === 401) {
        console.log("JWT Token Expired");

        localStorage.clear();
        navigate("/");
      } else {
        console.error("Failed to fetch profile picture");
      }
    } catch (error) {
      console.error("Failed to load profile picture", error);
    }
  };

  useEffect(() => {
    const loggedUser = JSON.parse(localStorage.getItem("user"));

    if (loggedUser?.emailId) {
      setUserName(loggedUser.userName || loggedUser.emailId);

      const token = loggedUser.jwtToken;

      fetch(
        `${API.V1}/floor_rooms/getViewsdataforDashboard?emailId=${loggedUser.emailId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
        .then((res) => {
          if (res.status === 401) {
            localStorage.clear();
            window.location.href = "/";
            throw new Error("Session Expired");
          }
          return res.json();
        })
        .then((data) => {
          if (data?.data) {
            setDashboardData(data.data);
          }
        })
        .catch((err) => console.error(err));
    }
  }, []);

  const goTo = (path) => navigate(path);

  const totalPaymentUsers =
    dashboardData.payment_due_usersCount +
    dashboardData.payment_No_pendingUsersCount;

  return (
    <div style={styles.container}>
      {/* SIDEBAR */}
      <div style={styles.sidebar}>
        <div style={styles.logoContainer}>
          <h1 style={styles.logo}>SVK PG</h1>
          <p style={styles.logoText}>Management System</p>
        </div>

        <ul style={styles.menuList}>
          {/* Dashboard */}
          <li>
            <div
              onClick={() => goTo("/dashboard")}
              onMouseEnter={() => setHoveredMenu("dashboard")}
              onMouseLeave={() => setHoveredMenu("")}
              style={{
                ...styles.link,
                ...(hoveredMenu === "dashboard" ? styles.linkHover : {}),
              }}
            >
              <FaHome />
              Dashboard
            </div>
          </li>

          {/* Floors Rooms Beds */}
          <li>
            <div
              onClick={() => goTo("/floorRoomsBeds")}
              onMouseEnter={() => setHoveredMenu("floorRoomsBeds")}
              onMouseLeave={() => setHoveredMenu("")}
              style={{
                ...styles.link,
                ...(hoveredMenu === "floorRoomsBeds" ? styles.linkHover : {}),
              }}
            >
              <FaBuilding />
              <span>
                <b>Create</b> (Floors • Rooms • Beds)
              </span>
            </div>
          </li>

          {/* Users Dashboard & Registration */}
          <li>
            <div
              onClick={() => goTo("/usersDashboard")}
              onMouseEnter={() => setHoveredMenu("usersDashboard")}
              onMouseLeave={() => setHoveredMenu("")}
              style={{
                ...styles.link,
                ...(hoveredMenu === "usersDashboard" ? styles.linkHover : {}),
              }}
            >
              <FaUsers />
              Bed Booking - Floor & Rooms Wise
            </div>
          </li>

          {/* Food Menu */}
          <li>
            <div
              onClick={() => goTo("/foodMenuList")}
              onMouseEnter={() => setHoveredMenu("foodMenu")}
              onMouseLeave={() => setHoveredMenu("")}
              style={{
                ...styles.link,
                ...(hoveredMenu === "foodMenu" ? styles.linkHover : {}),
              }}
            >
              <MdRestaurantMenu />
              Food Menu & Diet
            </div>
          </li>

          {/* Payments */}
          <li>
            <div
              onClick={() => goTo("/paymentsDashboard")}
              onMouseEnter={() => setHoveredMenu("payments")}
              onMouseLeave={() => setHoveredMenu("")}
              style={{
                ...styles.link,
                ...(hoveredMenu === "payments" ? styles.linkHover : {}),
              }}
            >
              <FaCreditCard />
              Payments Dashboard
            </div>
          </li>

          {/* Reports */}
          <li>
            <button
              type="button"
              onClick={() => goTo("/excelSheetUploadDownload")}
              onMouseEnter={() => setHoveredMenu("bulkExcel")}
              onMouseLeave={() => setHoveredMenu("")}
              style={{
                ...styles.link,
                ...(hoveredMenu === "bulkExcel" ? styles.linkHover : {}),
              }}
            >
              <FaFileExcel />
              <span>Upload Bulk Users By Excel</span>
            </button>
          </li>

          {/* Payment Settings */}
          <li>
            <div
              onClick={() => goTo("/upcomingFeatures")}
              onMouseEnter={() => setHoveredMenu("paymentSettings")}
              onMouseLeave={() => setHoveredMenu("")}
              style={{
                ...styles.link,
                ...(hoveredMenu === "paymentSettings" ? styles.linkHover : {}),
              }}
            >
              <FaChartBar />
              UpComing Features
            </div>
          </li>

          <li>
            <div
              onClick={handleLogout}
              onMouseEnter={() => setHoveredMenu("logout")}
              onMouseLeave={() => setHoveredMenu("")}
              style={{
                ...styles.link,
                ...(hoveredMenu === "logout" ? styles.logoutHover : {}),
              }}
            >
              🚪 Logout
            </div>
          </li>
        </ul>
      </div>

      {/* MAIN */}
      <div style={styles.main}>
        {/* HEADER */}
        <div style={styles.rightSection}>
          <div
            style={styles.iconContainer}
            onClick={() => navigate("/bedNotifications")}
          >
            <FaBed size={22} />
            <span style={styles.badge}>5</span>
          </div>

          <div
            style={styles.iconContainer}
            onClick={() => navigate("/notifications")}
          >
            <IoMdNotifications size={24} />
            <span style={styles.badge}>3</span>
          </div>

          <div
            style={styles.iconContainer}
            onClick={() =>
              navigate("/userPendingWorks", {
                state: {
                  userRegisterId: userRegisterId,
                },
              })
            }
          >
            <MdPendingActions size={30} />

            {pendingWorksCount > 0 && (
              <span style={styles.badge}>
                {pendingWorksCount > 99 ? "99+" : pendingWorksCount}
              </span>
            )}
          </div>

          <div
            style={styles.profile}
            onClick={() => navigate("/updateProfile")}
          >
            <img
              src={
                profilePic ||
                "https://cdn-icons-png.flaticon.com/512/149/149071.png"
              }
              alt="Profile"
              style={{
                width: "100px",
                height: "105px",
                borderRadius: "50%",
                objectFit: "cover",
                cursor: "pointer",
              }}
              onClick={() => navigate("/updateProfile")}
            />

            <div>
              <div style={styles.welcome}>Welcome</div>
              <div style={styles.userName}>
                {JSON.parse(localStorage.getItem("user"))?.userName}
              </div>
            </div>
          </div>
        </div>
        {/* <div style={styles.header}>
          <h2 style={styles.pageTitle}>Dashboard</h2>
        </div> */}

        {/* GRID */}
        <div style={styles.grid}>
          <div
            style={{ ...styles.card, ...styles.blueCard }}
            onClick={() => goTo("/floorRoomsBeds")}
          >
            <div style={styles.icon}>🏢</div>
            <h3>Total Floors</h3>
            <h1>{dashboardData.totalFloorsCount}</h1>
          </div>

          <div
            style={{ ...styles.card, ...styles.greenCard }}
            onClick={() => goTo("/floorRoomsList")}
          >
            <div style={styles.icon}>🚪</div>
            <h3>Total Rooms</h3>
            <h1>{dashboardData.totalRoomsCount}</h1>
          </div>

          <div
            style={{ ...styles.card, ...styles.orangeCard }}
            onClick={() => goTo("/bedsListForm")}
          >
            <div style={styles.icon}>🛏</div>
            <h3>Total Beds</h3>
            <h1>{dashboardData.totalBedsCount}</h1>
          </div>

          <div
            style={{ ...styles.card, ...styles.purpleCard }}
            onClick={() => goTo("/allAvailableBeds")}
          >
            <div style={styles.icon}>✅</div>
            <h3>Available Beds</h3>
            <h1>{dashboardData.availableBedsCount}</h1>
          </div>

          <div
            style={{ ...styles.card, ...styles.cyanCard }}
            onClick={() => goTo("/tenantsAndGuests")}
          >
            <div style={styles.icon}>👤</div>
            <h3>Total Bookings</h3>
            <h1>{dashboardData.totalUsersCountInPg}</h1>

            <div style={styles.userBreakdown}>
              <div>🏠 Tenants: {dashboardData.totalTenentUsersCount}</div>
              <div>👥 Guests: {dashboardData.guestUsersCount}</div>
            </div>
          </div>

          <div
            style={{ ...styles.card, ...styles.darkCard }}
            onClick={() => goTo("/readyToJoinUsers")}
          >
            <div style={styles.icon}>⏳</div>

            <h3>Ready To Join </h3>

            <h1>{dashboardData.readyToJoiningUsersCount}</h1>

            {/* Ready To Vacate Count */}
            <div
              style={{
                marginTop: "10px",
                paddingTop: "10px",
                borderTop: "1px solid rgba(255,255,255,0.3)",
                width: "100%",
                textAlign: "center",
              }}
            >
              <span style={{ fontSize: "14px" }}>🚪 Ready To Vacate</span>

              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginTop: "3px",
                }}
              >
                {dashboardData.readyTovacatUsersCount}
              </div>
            </div>
          </div>

          {/* USER PAYMENT DETAILS */}
          <div
            style={{ ...styles.card, ...styles.redCard }}
            onClick={() => goTo("/showUserPaymentDetails")}
          >
            <div style={styles.icon}>💳</div>

            <h3>User Payments </h3>
            <h1>{totalPaymentUsers}</h1>

            <div style={styles.userBreakdown}>
              <div>
                ✅ Payment Cleared: {dashboardData.payment_No_pendingUsersCount}
              </div>

              <div>
                ⏳ Payment Pending: {dashboardData.payment_due_usersCount}
              </div>
            </div>
          </div>

          {/* REFERRALS */}
          <div
            style={{ ...styles.card, ...styles.referralCard }}
            onClick={() => goTo("/referralList")}
          >
            <div style={styles.icon}>🎁</div>

            <h3>Referrals</h3>

            <h1>{dashboardData.totalRefferalsCount || 0}</h1>

            <div style={styles.userBreakdown}>
              <div>
                💰 Referral Amount: ₹{dashboardData.totalRefferalsAmount || 0}
              </div>

              <div>
                ✅ Referral Paid: ₹{dashboardData.referralPaidAmount || 0}
              </div>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div style={styles.footer}>All Rights Reserved © 2026</div>
      </div>
    </div>
  );
}

export default FloorRooms;

/* ===================== STYLES ===================== */

const styles = {
  container: {
    display: "flex",
    minHeight: "100vh",
    background: "#eef2ff",
    fontFamily: "Arial, sans-serif",
  },

  sidebar: {
    width: "270px",
    background: "linear-gradient(180deg,#0f172a,#1e293b)",
    color: "#fff",
    padding: "25px 18px",
  },

  logoContainer: {
    textAlign: "center",
    marginBottom: "35px",
  },

  logo: {
    margin: 0,
    color: "#38bdf8",
    fontSize: "32px",
  },

  logoText: {
    color: "#cbd5e1",
    fontSize: "14px",
  },

  menuList: {
    listStyle: "none",
    padding: 0,
  },

  link: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    padding: "15px 18px",
    marginBottom: "12px",
    borderRadius: "14px",
    background: "rgba(255,255,255,0.05)",
    color: "#e2e8f0",
    cursor: "pointer",
    transition: "all .35s ease",
    fontSize: "15px",
    fontWeight: "600",
  },

  linkHover: {
    background: "linear-gradient(90deg,#2563eb,#3b82f6)",
    color: "#ffffff",
    transform: "translateX(12px)",
    boxShadow: "0 12px 25px rgba(37,99,235,.40)",
    borderLeft: "5px solid #38bdf8",
  },

  activeLink: {
    display: "flex",
    gap: "10px",
    padding: "12px",
    marginBottom: "10px",
    borderRadius: "10px",
    background: "#2563eb",
    fontWeight: "bold",
    cursor: "pointer",
  },

  activeLink: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    padding: "15px 18px",
    marginBottom: "12px",
    borderRadius: "14px",
    background: "linear-gradient(90deg,#2563eb,#1d4ed8)",
    color: "#fff",
    fontWeight: "700",
    transform: "translateX(12px)",
    borderLeft: "5px solid #38bdf8",
    boxShadow: "0 12px 25px rgba(37,99,235,.40)",
  },

  main: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },

  profileLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  profileIcon: {
    width: "42px",
    height: "42px",
    borderRadius: "50%",
    border: "2px solid #2563eb",
  },

  welcomeText: {
    fontSize: "18px",
    fontWeight: "bold",
  },

  userName: {
    color: "#2563eb",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "25px",
    padding: "20px 30px",
  },

  card: {
    borderRadius: "22px",
    padding: "28px",
    color: "#fff",
    boxShadow: "0 12px 25px rgba(0,0,0,0.12)",
    cursor: "pointer",
  },

  icon: { fontSize: "42px", marginBottom: "14px" },

  blueCard: { background: "linear-gradient(135deg,#2563eb,#60a5fa)" },
  greenCard: { background: "linear-gradient(135deg,#059669,#34d399)" },
  orangeCard: { background: "linear-gradient(135deg,#ea580c,#fb923c)" },
  purpleCard: { background: "linear-gradient(135deg,#7c3aed,#a78bfa)" },
  cyanCard: { background: "linear-gradient(135deg,#0891b2,#22d3ee)" },
  redCard: { background: "linear-gradient(135deg,#dc2626,#f87171)" },
  tealCard: { background: "linear-gradient(135deg,#0f766e,#2dd4bf)" },
  darkCard: { background: "linear-gradient(135deg,#1e293b,#475569)" },
  yellowCard: { background: "linear-gradient(135deg,#ca8a04,#fde047)" },
  grayCard: { background: "linear-gradient(135deg,#4b5563,#9ca3af)" },

  userBreakdown: {
    marginTop: "12px",
    fontSize: "14px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    color: "#fff",
    opacity: 0.95,
  },

  referralCard: {
    background: "linear-gradient(135deg, #9333ea, #c084fc)",
    color: "#fff",
    borderRadius: "22px",
    padding: "28px",
    boxShadow: "0 12px 25px rgba(147, 51, 234, 0.30)",
    cursor: "pointer",
    transition: "all 0.3s ease",
    border: "1px solid rgba(255,255,255,0.2)",
  },

  footer: {
    textAlign: "center",
    padding: "12px",
    background: "#0f172a",
    color: "#fff",
    marginTop: "auto",
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },

  iconContainer: {
    position: "relative",
    cursor: "pointer",
    background: "#fff",
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 10px rgba(0,0,0,.15)",
    transition: "0.3s",
  },

  badge: {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    background: "red",
    color: "#fff",
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "11px",
    fontWeight: "bold",
  },

  profile: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
    background: "#fff",
    padding: "6px 15px",
    borderRadius: "30px",
    boxShadow: "0 4px 10px rgba(0,0,0,.15)",
  },

  profileImage: {
    width: "42px",
    height: "42px",
    borderRadius: "50%",
    objectFit: "cover",
  },

  welcome: {
    fontSize: "12px",
    color: "#666",
  },

  logoutHover: {
    background: "linear-gradient(90deg,#dc2626,#ef4444)",
    color: "#fff",
    transform: "translateX(12px)",
    borderLeft: "5px solid #fca5a5",
    boxShadow: "0 12px 25px rgba(220,38,38,.35)",
  },

  userName: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#1e293b",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "25px",
  },

  pageTitle: {
    margin: 0,
    fontSize: "28px",
    fontWeight: "700",
    color: "#1e293b",
  },

  logoutBtn: {
    background: "linear-gradient(135deg,#ef4444,#dc2626)",
    color: "#fff",
    border: "none",
    padding: "10px 22px",
    borderRadius: "10px",
    fontSize: "15px",
    fontWeight: "700",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    boxShadow: "0 6px 14px rgba(220,38,38,0.3)",
    transition: "0.3s",
  },
};
